<script setup>
  import { ref, computed, defineAsyncComponent, onErrorCaptured } from 'vue'
  import { useSheetContentComponent } from '@/composables/useSheetContentComponent';
  import { useSheetController } from "@/composables/useSheetsController";
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import SheetBase from "@/components/SheetBase.vue";
  import LoaderCircle from '@/components/LoaderCircle.vue';

  const props = defineProps({
    position: {
      type: String,
      default: 'primary'
    }
  });

  const type = 'storm';
  const isDesktop = useMediaQuery('(min-width: 840px)');

  let error = ref(null);

  useSheetController.registerSheet(type, props.position);

  const components = {
    SheetContentStormAdvisory: defineAsyncComponent(() => import('@/components/SheetContentStormAdvisory.vue')),
  };

  const isSheetOpen = computed(() => {
    return useSheetController.sheets[type].open;
  })

  const startingHeightState = computed(() => isDesktop.value ? 'maximized' : 'mid');

  onErrorCaptured((e) => {
    error.value = e;
    console.warn(e);

    return true;
  })
</script>

<template>
  <SheetBase 
    :type="type" 
    :starting-height-state="startingHeightState" 
    :position="props.position"
    v-slot="{ transtionName }"
    >
    <Suspense timeout="200">
      <component 
        v-if="isSheetOpen" 
        :is="useSheetContentComponent(type, components)"
        :type="type"
        :transtionName="transtionName"
      />

      <template #fallback>
        <LoaderCircle />
      </template>        
    </Suspense>
  </SheetBase>
</template>